export default "__VITE_ASSET__c722c2a7__"